import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import { getUrlProps } from "helpers/landing"

const PictureImage = styled(Box).attrs((props) => ({
  as: "img",
  width: "100%",
  ...props,
}))`
  display: block;
  ${(props) =>
    props.wideImage &&
    `
    ${props.theme.mediaQueries.tablet`
      width: auto;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    `}
  `};
`

const LandingImageWrapper = styled(Box)`
  display: block;
  overflow: hidden;
  position: relative;
`

const LandingImage = ({ element, lazyload }) => {
  const assetPath = `${sl.config.jewlr_asset_url}landing/${element.jpg_name}`
  const wideImage = element.jpg_name.match(/(extended|fullsize)$/)
  const urlProps = getUrlProps(
    element.image_url,
    element?.anchor_name || element?.id
  )

  return (
    <LandingImageWrapper
      containWide={wideImage ? 0 : 1}
      element={element}
      id={element.anchor_name}
      {...urlProps}
    >
      {lazyload ? (
        <picture>
          <source
            data-srcset={`${assetPath}/mobile.jpg`}
            media="(max-width: 767px)"
          />
          {wideImage && (
            <source
              data-srcset={`
              ${assetPath}/tablet.jpg 1x,
              ${assetPath}/tablet_2x.jpg 2x
            `}
              media="(min-width: 768px) and (max-width: 1023px)"
            />
          )}
          <source
            data-srcset={`
            ${assetPath}/desktop.jpg 1x,
            ${assetPath}/desktop_2x.jpg 2x
          `}
            media={`(min-width: ${wideImage ? "1024" : "768"}px)`}
          />
          <PictureImage
            className="lazyload"
            data-src={`${assetPath}/desktop_2x.jpg`}
            src={require("images/icons/jewlr.gif")}
            style={{ width: "100%" }}
            wideImage={wideImage}
          />
        </picture>
      ) : (
        <picture>
          <source
            media="(max-width: 767px)"
            srcSet={`${assetPath}/mobile.jpg`}
            type="image/jpeg"
          />
          {wideImage && (
            <source
              media="(min-width: 768px) and (max-width: 1023px)"
              srcSet={`
              ${assetPath}/tablet.jpg 1x,
              ${assetPath}/tablet_2x.jpg 2x
            `}
              type="image/jpeg"
            />
          )}
          <source
            media={`(min-width: ${wideImage ? "1024" : "768"}px)`}
            srcSet={`
            ${assetPath}/desktop.jpg 1x,
            ${assetPath}/desktop_2x.jpg 2x
          `}
            type="image/jpeg"
          />
          <PictureImage
            src={`${assetPath}/desktop_2x.jpg`}
            style={{ width: "100%" }}
            wideImage={wideImage}
          />
        </picture>
      )}
    </LandingImageWrapper>
  )
}

LandingImage.propTypes = {
  element: PropTypes.object.isRequired,
  lazyload: PropTypes.bool,
}

export default LandingImage
